/* eslint-disable @typescript-eslint/no-namespace */
// ^ allowing namespaces reduces collisions for these names
import { TranslationKey } from "../i18n";

import model from "./model.json";

export const footerModel = model.mainModel as Array<FooterNodeType.Parent>;
export const socialsModels = model.socials as Array<FooterNodeType.Link>;

export interface FooterHref {
  en: string;
  ja?: string;
  "zh-cn"?: string;
}

export namespace FooterNodeType {
  type Base = {
    titleKey: TranslationKey;
  };

  export type Parent = Base & {
    childNodes: Array<Link>;
  };

  export type Link = Base & {
    superTitleKey?: TranslationKey;
    newTab?: true;
    href: FooterHref;
  };
}
